import '@babel/polyfill'; // eslint-disable-line
import Vue from 'vue';
import VueGtm from 'vue-gtm';
import VeeValidate, { Validator } from 'vee-validate';
import VeeValidateMessagesPL from 'vee-validate/dist/locale/pl';
import VueObserveVisibility from 'vue-observe-visibility';
import VueLodash from 'vue-lodash';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store/store';
import './registerServiceWorker';
import EventBus from './helpers/event-bus';

require('intersection-observer');

const VueScrollTo = require('vue-scrollto');

/**
 * Globalne wyłaczenie drag'n'drop na wszystkich elementach aplikacji.
 * Zapobiega to standardowemu działaniu przeglądarki polegającym na tym, że wrzucenie
 * pliku powoduje otwarcie tego pliku.
 * Tam gdzie drag'n'drop jest potrzebny, to obsługjemy go normalnie odpowiednimi eventami.
 */
document.addEventListener(
  'dragover',
  (event) => {
    event.preventDefault();
    return false;
  },
  false,
);
document.addEventListener(
  'drop',
  (event) => {
    event.preventDefault();
    return false;
  },
  false,
);

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

Vue.use(VueGtm, {
  id: 'GTM-WBJMZ7W',
  debug: false,
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});

// use vee validate for validation;
Validator.localize('pl', VeeValidateMessagesPL);
Vue.use(VeeValidate, {
  locale: 'pl',
});
Vue.use(VueLodash);

Vue.use(VueObserveVisibility);
Vue.directive('observe-visibility', VueObserveVisibility.ObserveVisibility);

Vue.prototype.$eventBus = EventBus;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
